<script lang="ts">
</script>

<div class="container">
  <h2 class="title pro">REKKI INSIGHTS</h2>
  <h3 class="subtitle">All your invoices in one place.<br />See your spend in real time.</h3>
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    max-width: min-content;
  }
  .title {
    font-family: "REKKI-Medium", sans-serif;
    font-weight: 400;
    font-size: 60px;
    line-height: 58px;
    letter-spacing: -3.5px;
    margin-bottom: 16px;
    white-space: nowrap;
  }
  .subtitle {
    font-family: "REKKI-Medium", sans-serif;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.6px;
    width: 100%;
    font-weight: 400;
    color: var(--rekki-transparency-dark);
    margin-bottom: 50px;
  }
</style>
